module.exports = __webpack_public_path__ + "static/media/customUrl.703be5f1.png";